import "./instrument.js";
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";

// React 19: use Sentry's error handlers for onCaughtError and onUncaughtError
createRoot(document.getElementById("root"), {
  onCaughtError: Sentry.reactErrorHandler(),
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error:", error, errorInfo.componentStack);
  }),
}).render(<App />);
